import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import saidaProduto from '../services/saidaService';

const initialState = {
  error: false,
  success: false,
  loading: false,
  saidas: [],
};

export const postSaidaProduto = createAsyncThunk(
  'saidaProduct/postSaida',
  async (data, thunkAPI) => {
    const response = await saidaProduto.postSaidaProduct(data);
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response.data;
  }
);

export const getSaidaProduto = createAsyncThunk('saidaProduct/getSaida', async (_, thunkAPI) => {
  const response = await saidaProduto.getSaidaProduto();

  if (response.errors) {
    return thunkAPI.rejectWithValue(response.errors);
  }
  return response;
});

export const postSaidaNaoAutorizado = createAsyncThunk(
  'saidaProduct/postNaoAutorizada',
  async (data, thunkAPI) => {
    const response = await saidaProduto.postSaidaNaoRegistrada(data);
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response.data;
  }
);

export const saidaProductSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postSaidaProduto.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postSaidaProduto.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(postSaidaProduto.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getSaidaProduto.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSaidaProduto.fulfilled, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = null;
        state.saidas = action.payload;
      })
      .addCase(getSaidaProduto.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })
      .addCase(postSaidaNaoAutorizado.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postSaidaNaoAutorizado.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(postSaidaNaoAutorizado.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { reset } = saidaProductSlice.actions;
export default saidaProductSlice.reducer;
